export type OrgRow = {
  orgId: number;
  name: string;
  orgType: string;
  enabled: boolean;
  config: Record<string, unknown>;
};

export function readOrgUrl(
  config: Record<string, unknown> | undefined,
): string {
  const v = config?.url;
  return typeof v === "string" ? v : "";
}

/** Org API tokens are redacted to `{ set: boolean }` on listOrgs. */
export function readTokenSet(
  config: Record<string, unknown> | undefined,
): boolean {
  const v = config?.token;
  if (v && typeof v === "object" && "set" in v) {
    return !!(v as { set: boolean }).set;
  }
  return false;
}
